import { render, staticRenderFns } from "./bouton-dictee.vue?vue&type=template&id=2c645f8a&scoped=true"
import script from "./bouton-dictee.vue?vue&type=script&lang=js"
export * from "./bouton-dictee.vue?vue&type=script&lang=js"
import style0 from "./bouton-dictee.vue?vue&type=style&index=0&id=2c645f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c645f8a",
  null
  
)

export default component.exports